import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/ap_auto_appCommonService";

const initialState = {
  apSample: {
    data: [],
    status: false,
    articleNr: "",
    workflow: [],
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  budget: {
    data: [],
    status: false,
    budgetNr: "",
    workflow: [],
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  apInv: {
    data: [],
    status: false,
    apInvNr: "",
    workflowInv: [],
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  vendor: {
    data: [],
    status: false,
    vendorNr: "",
    workflow: [],
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  arcustomer: {
    data: [],
    status: false,
    customerNr: "",
    workflow: [],
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  payment: {
    data: [],
    status: false,
    paymentNr: "",
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  apPo: {
    data: [],
    status: false,
    poNr: "",
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
  apSalesOrder: {
    data: [],
    status: false,
    apSoNr: "",
    pagination: {
      page: 1,
      per_page: 10,
      total: 0,
    },
  },
};

export const plmSlice = createSlice({
  name: "apauto",
  initialState,
  reducers: {
    addBudgetNr(state, action) {
      state.budget.budgetNr = action.payload;
    },
    addAPINV(state, action) {
      state.apInv.apInvNr = action.payload;
    },
    addVendor(state, action) {
      state.vendor.vendorNr = action.payload;
    },
    addarCustomer(state, action) {
      state.arcustomer.customerNr = action.payload;
    },
    addPaymentNr(state, action) {
      state.payment.paymentNr = action.payload;
    },
    workflowInv(state, action) {
      state.apInv.workflow = action.payload;
    },
    addPoNr(state, action) {
      state.apPo.poNr = action.payload;
    },
    addSalesOrder(state,action){
      state.apSalesOrder.apSoNr=action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBudgetList.pending, (state) => {
        state.budget.status = true;
      })
      .addCase(getBudgetList.fulfilled, (state, action) => {
        state.budget.data = action.payload?.data || [];
        state.budget.pagination.page = action.payload?.page || 1;
        state.budget.pagination.per_page = action.payload?.per_page || 10;
        state.budget.pagination.total = action.payload?.total || 0;
        state.budget.status = false;
      })
      .addCase(getBudgetList.rejected, (state, action) => {
        state.budget.status = false;
      })
      .addCase(getAPInvList.pending, (state, action) => {
        state.apInv.status = true;
      })
      .addCase(getAPInvList.fulfilled, (state, action) => {
        state.apInv.data = action.payload?.data || [];
        state.apInv.pagination.page = action.payload?.page || 1;
        state.apInv.pagination.per_page = action.payload?.per_page || 10;
        state.apInv.pagination.total = action.payload?.total || 0;
        state.apInv.status = false;
      })
      .addCase(getAPInvList.rejected, (state, action) => {
        state.apInv.status = false;
      })
      .addCase(getVendorList.pending, (state, action) => {
        state.vendor.status = true;
      })
      .addCase(getVendorList.fulfilled, (state, action) => {
        state.vendor.data = action.payload?.data || [];
        state.vendor.pagination.page = action.payload?.page || 1;
        state.vendor.pagination.per_page = action.payload?.per_page || 10;
        state.vendor.pagination.total = action.payload?.total || 0;
        state.vendor.status = false;
      })
      .addCase(getVendorList.rejected, (state, action) => {
        state.vendor.status = false;
      })
      .addCase(getArCustomerList.pending, (state, action) => {
        state.arcustomer.status = true;
      })
      .addCase(getArCustomerList.fulfilled, (state, action) => {
        state.arcustomer.data = action.payload?.data || [];
        state.arcustomer.pagination.page = action.payload?.page || 1;
        state.arcustomer.pagination.per_page = action.payload?.per_page || 10;
        state.arcustomer.pagination.total = action.payload?.total || 0;
        state.arcustomer.status = false;
      })
      .addCase(getArCustomerList.rejected, (state, action) => {
        state.arcustomer.status = false;
      })
      .addCase(getPaymentList.pending, (state, action) => {
        state.payment.status = true;
      })
      .addCase(getPaymentList.fulfilled, (state, action) => {
        state.payment.data = action.payload?.data || [];
        state.payment.pagination.page = action.payload?.page || 1;
        state.payment.pagination.per_page = action.payload?.per_page || 10;
        state.payment.pagination.total = action.payload?.total || 0;
        state.payment.status = false;
      })
      .addCase(getPaymentList.rejected, (state, action) => {
        state.payment.status = false;
      })
      .addCase(getApPoList.pending, (state, action) => {
        state.apPo.status = true;
      })
      .addCase(getApPoList.fulfilled, (state, action) => {
        state.apPo.data = action.payload?.data || [];
        state.apPo.pagination.page = action.payload?.page || 1;
        state.apPo.pagination.per_page = action.payload?.per_page || 10;
        state.apPo.pagination.total = action.payload?.total || 0;
        state.apPo.status = false;
      })
      .addCase(getApPoList.rejected, (state, action) => {
        state.apPo.status = false;
      })
      .addCase(getSalesOrder.pending, (state, action) => {
        state.apSalesOrder.status = true;
      })
      .addCase(getSalesOrder.fulfilled, (state, action) => {
        state.apSalesOrder.data = action.payload?.data || [];
        state.apSalesOrder.pagination.page = action.payload?.page || 1;
        state.apSalesOrder.pagination.per_page = action.payload?.per_page || 10;
        state.apSalesOrder.pagination.total = action.payload?.total || 0;
        state.apSalesOrder.status = false;
      })
      .addCase(getSalesOrder.rejected, (state, action) => {
        state.apSalesOrder.status = false;
      });
  },
});

export const getBudgetList = createAsyncThunk(
  "budget/getBudgetList",
  async (param, { rejectWithValue }) => {
    try {
      console.log(">> loaded getBudgetList");
      const res = await ItemService.generatePlmQuery(param);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Something went wrong");
    }
  },
);

export const getAPInvList = createAsyncThunk("getAPInvList", async (param) => {
  console.log(">> loaded getAPInvList");
  const res = await ItemService.generateCustomerQuery(param);
  return res;
});

export const getVendorList = createAsyncThunk(
  "getVendorList",
  async (param) => {
    console.log(">> loaded getVendorList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);

export const getArCustomerList = createAsyncThunk(
  "getArCustomerList",
  async (param) => {
    console.log(">> loaded getArCustomerList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getPaymentList = createAsyncThunk(
  "getPaymentList",
  async (param) => {
    console.log(">> loaded getPaymentList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getApPoList = createAsyncThunk(
  "getApPoList",
  async (param) => {
    console.log(">> loaded getApPoList");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);
export const getSalesOrder = createAsyncThunk(
  "getSalesOrder",
  async (param) => {
    console.log(">> loaded getSalesOrder");
    const res = await ItemService.generateCustomerQuery(param);
    return res;
  },
);
export const {
  addBudgetNr,
  addAPINV,
  addVendor,
  addarCustomer,
  addPaymentNr,
  workflowInv,
  addPoNr,
  addSalesOrder
} = plmSlice.actions;

export default plmSlice.reducer;
